export const HideExternalLinkWarningStorageKey = '__HideExternalLinkWarnings__';
export const HideDownloadWarningStorageKey = '__HideDownloadWarnings__';
